import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useMonitoringModel } from "../monitoringModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    const { exportMonitoring, descTotal } = useMonitoringModel();

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.STT_SPS_EX}> */}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => exportMonitoring()}
        >导出</Button>
        {/* </YhAuth> */}
    </>;
    const desc: any = [
        {
            label: "工时数差异",
            value: descTotal.itemNumDiff ?? 0,
            color: descTotal.itemNumDiff != 0 ? DescriptionColorEnum.green : DescriptionColorEnum.red,
            // animation: (descTotal.amountDiff != 0
        },
        {
            label: "配件数差异",
            value: descTotal.numDiff ?? 0,
            color: descTotal.numDiff != 0 ? DescriptionColorEnum.green : DescriptionColorEnum.red,
            // animation: (descTotal.beforeAmountDiff != 0
        },
        {
            label: "工时费差异",
            value: (descTotal.itemAmountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.itemAmountDiff ?? 0) != 0
        },
        {
            label: "配件费差异",
            value: (descTotal.amountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.amountDiff ?? 0) != 0
        },
        {
            label: "优惠后工时差异",
            value: (descTotal.receivedItemAmountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.receivedItemAmountDiff ?? 0) != 0
        },
        {
            label: "优惠后配件差异",
            value: (descTotal.receivedMaterialAmountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.receivedMaterialAmountDiff ?? 0) != 0
        },
        {
            label: "费用合计差异",
            value: (descTotal.totalAmountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.totalAmountDiff ?? 0) != 0
        },
        {
            label: "营业额差异",
            value: (descTotal.dreceivedAmountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.dreceivedAmountDiff ?? 0) != 0
        },
        {
            label: "销售成本差异",
            value: (descTotal.costAmountDiff ?? 0).toFixed(2),
            color: DescriptionColorEnum.red,
            animation: (descTotal.costAmountDiff ?? 0) != 0
        },
    ]
    return (
        <YhBox title={action} descriptions={desc} style={{ height: 'calc(100vh - 200px)' }}>
            <DataTable />
        </YhBox>
    )
}